export default __webpack_public_path__ + "static/media/PPI-pools-008.0b4e3393.jpg";